import ModalContainer, { ModalContainerProps } from "components/common/ModalContainer";
import React, { useEffect } from "react";
import { ForecastNewProductContentProps } from "./types/ForecastNewProductStepForm";
import Button from "components/common/Button";
import { FORECAST_NEW_PRODUCT_STEP } from "./constant/ForecastNewProductStepConstant";
import clsx from "clsx";

import ForecastNewProductPlanAddEdit from "./ForecastNewProductPlanAddEdit";

type ForecastNewProductPlanProps = {} & ForecastNewProductContentProps &
    Omit<ModalContainerProps, "children">;

export default function ForecastNewProductPlan(props: ForecastNewProductPlanProps) {
    const { stepper, formik, tailwindClassName, ...rest } = props;
    useEffect(() => {
        formik.validateForm();
    }, []);

    return (
        <ModalContainer
            {...rest}
            closeModal={() => {}}
            tailwindClassName={clsx("max-w-[1062px]", tailwindClassName)}
        >
            <div>
                <div className="flex justify-between items-center px-[24px] py-[16px]">
                    <p className="text-[18px]  font-rocGroteskMedium">
                        Plan forecast for a new product
                    </p>
                    <div className="flex items-center gap-[8px]">
                        <Button
                            btnText="View all planned products"
                            onClick={() => {
                                stepper.go(FORECAST_NEW_PRODUCT_STEP.PLAN_LIST);
                            }}
                            btnClassname="!bg-white !border !border-n-20 !py-3 !px-2  !w-fit !h-[32px] rounded-[5px] !text-[#0054C2] !shadow-sm"
                            icon={<i className="ri-line-chart-line text-lg"></i>}
                            // btnType=""
                        />

                        <button
                            onClick={rest.closeModal}
                            className="!bg-white !border  !border-n-20 flex items-center justify-center !py-3 !px-2 !w-fit !h-[32px] rounded-[5px] shadow-sm"
                        >
                            <i className="ri-close-line"></i>
                        </button>
                    </div>
                </div>

                <hr className="border-[#E2E8F0]" />

                <ForecastNewProductPlanAddEdit
                    className="px-[32px] py-[12px] max-h-[600px] overflow-y-auto"
                    formik={formik}
                    stepper={stepper}
                />

                <hr className="border-[#E2E8F0]" />

                <div className="flex gap-[8px] px-[24px] py-[12px]">
                    <div />

                    <div className="flex-1"></div>
                    <Button
                        btnText="Cancel"
                        onClick={rest.closeModal}
                        btnClassname="!bg-[#F4F5F7] cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                    <Button
                        btnText="Generate forecast"
                        disabled={!formik?.isValid}
                        isLoading={formik?.isSubmitting}
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                        btnClassname="!bg-[#FFB903] cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                </div>
            </div>
        </ModalContainer>
    );
}
